import { render, staticRenderFns } from "./EmptyExaminationInfo.vue?vue&type=template&id=c6be46be"
import script from "./EmptyExaminationInfo.vue?vue&type=script&lang=js"
export * from "./EmptyExaminationInfo.vue?vue&type=script&lang=js"
import style0 from "./EmptyExaminationInfo.vue?vue&type=style&index=0&id=c6be46be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports